import { app } from "@tva/app";
import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";
import { CourseManagementComponent } from "./components/search/course-management.component";
import { CourseManagementAddComponent } from "@tva/ng-migration/course-management/components/add/course-management-add.component";
import { CourseManagementEditComponent } from "./components/edit/course-management-edit.component";

app.directive(
  "appCourseManagement",
  downgradeComponent({
    component: CourseManagementComponent,
  }) as angular.IDirectiveFactory
);

app.directive(
  "appCourseManagementAdd",
  downgradeComponent({
    component: CourseManagementAddComponent,
  }) as angular.IDirectiveFactory
);

app.directive(
  "appCourseManagementEdit",
  downgradeComponent({
    component: CourseManagementEditComponent,
  }) as angular.IDirectiveFactory
);
